module.exports = __webpack_public_path__ + "static/social_instagram-9ab2e19f6665ea952e8f3782b181176e.png";